import { render, staticRenderFns } from "./upload-presc-data.html?vue&type=template&id=8de9aa3e&scoped=true&external"
import script from "./upload-presc-data.js?vue&type=script&lang=js&external"
export * from "./upload-presc-data.js?vue&type=script&lang=js&external"
import style0 from "./upload-presc-data.scss?vue&type=style&index=0&id=8de9aa3e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de9aa3e",
  null
  
)

export default component.exports